import Button from "devextreme-react/button";
import { useContext } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { LoadPagePanel } from "../../../../components";
import { QuoteStatus, QuoteTypes } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useUpdateEstimate } from "../api/update-estimate";
import { EstimateContext } from "../context/EstimateContext";
import { EstimateProgressStep } from "../types/EstimateProgressStep";
import { EstimateUpdateType } from "../types/UpdateEstimateParams";

export default function SaveButton(params: { step: EstimateProgressStep }) {

	const navigate = useNavigate();
	const location = useLocation();

	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");

	const { order, refetchOrder } = useContext(EstimateContext);

	const isOrderReadonly = order.details.statusID === QuoteStatus.Closed ||
		order.details.statusID === QuoteStatus.Cancelled || order.details.statusID === QuoteStatus.Expired;

	let updateType: EstimateUpdateType;

	switch (params.step) {
		case EstimateProgressStep.Info:
			updateType = EstimateUpdateType.Info;
			break;

		case EstimateProgressStep.Contact:
			updateType = EstimateUpdateType.CustomerContact;
			break;

		case EstimateProgressStep.Schedule:
			updateType = EstimateUpdateType.Schedule;
			break;
	}

	const updateEstimate = useUpdateEstimate(
		{ estimate: order.details, updateType: updateType! },
		(result) => {
			showSuccessMessage(`${order.details.quoteTypeID === QuoteTypes.Lead ? "Lead" : "Estimate"} has been updated`);
			refetchOrder()
				.then(() => {
					if (params.step !== EstimateProgressStep.Info) {
						const newActionRequiredID = result.activeARs[0];

						const to = `/cfi/estimate/${order.details.quoteID}/${newActionRequiredID}` +
							(!!returnUrl ? '?returnUrl=' + returnUrl : '');

						if (newActionRequiredID && location.pathname !== to) {
							navigate(to);
						}
					}
				})
		},
		(error) => showErrorMessage(error)
	);

	return (
		<>
			<Button
				text="Save Changes"
				icon="Inscyth-Save"
				visible={!isOrderReadonly}
				disabled={!order.modified || updateEstimate.isLoading}
				onClick={(e) => {
					let result = e.validationGroup.validate();
					if (result.isValid) {
						updateEstimate.mutate();
					}
				}} >
			</Button>
			<LoadPagePanel visible={updateEstimate.isLoading} />
		</>
	)
}
